<template>
    <div>
        <pageHead :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></pageHead>
        <div class="content">
            <div class="search">
                <i-form ref="search" :model="query">
                    <row :gutter="80">
                        <i-col span="6">
                            <form-item label="不动产单元号" prop="estateUnitNO">
                                <Input v-model="query.estateUnitNO" clearable placeholder="请输入不动产单元号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="承租方" prop="leasee">
                                <Input v-model="query.leasee" clearable placeholder="请输入不动产单元号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="承租方证件号" prop="leaseeCode">
                                <Input v-model="query.leaseeCode" clearable placeholder="请输入不动产单元号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="出租方" prop="leasor">
                                <Input v-model="query.leasor" clearable placeholder="请输入不动产单元号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="出租方证件号" prop="leasorCode">
                                <Input v-model="query.leasorCode" clearable placeholder="请输入不动产单元号" />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="用途" prop="zlyt">
                                <Select v-model="query.zlyt" clearable>
                                    <Option v-for="item in zlyt" :key="item" :value="item" :label="item"></Option>
                                </Select>
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="租赁开始时间" prop="compactStartdate">
                                <DatePicker type="date" clearable v-model="query.compactStartdate" style="width: 100%;"></DatePicker>
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="租赁结束时间" prop="compactEnddate">
                                <DatePicker type="date" clearable v-model="query.compactEnddate" style="width: 100%;"></DatePicker>
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="合同状态" prop="orderStatus">
                                <Select v-model="query.orderStatus" clearable>
                                    <Option v-for="item in orderStatusData" :key="item" :value="item.value" :label="item.label"></Option>
                                </Select>
                            </form-item>
                        </i-col>
                    </row>
                </i-form>
            </div>
            <div class="table-data">
                <i-table :columns="tableHeader" :border="true" :loading="isLoading" :data="tableData" stripe ref="table" @on-row-dblclick="handleClickDetail1" @on-selection-change="handleSelect">
                    <template slot-scope="{ row, index }" slot="address">
                        <p><b>{{row.houseAddress}}</b></p>
                        <p style="color: #666;font-size: 12px">{{row.estateUnitNO}}</p>
                    </template>
                    <template slot-scope="{ row, index }" slot="leasor">
                        <p><b>{{row.leasor}}</b></p>
                        <p style="color: #666;font-size: 12px;margin-top: 5px;">{{row.leasorCode}}</p>
                    </template>
                    <template slot-scope="{ row, index }" slot="leasee">
                        <p><b>{{row.leasee}}</b></p>
                        <p style="color: #666;font-size: 12px;margin-top: 5px;">{{row.leaseeCode}}</p>
                    </template>
                    <template slot-scope="{ row, index }" slot="compactData">
                        <p>{{row.compactStartdate | formatData}}</p>
                        <p style="margin-top: 5px;">{{row.compactEnddate | formatData}}</p>
                    </template>
                    <template slot-scope="{ row, index }" slot="orderStatus">
                        <p :style="`color:${row.orderStatus==3 ? '#f00' : '#666'}`">{{row.orderStatus==2 ? '已完成' : row.orderStatus==3 ? '已注销' : ''}}</p>
                    </template>
                    <template slot-scope="{ row, index }" slot="action">
                        <span @click="handleClickDetail(row, 'detail')" class="action">[详情]</span>

                        <Poptip v-if="'2'==query.orderStatus" confirm title="确定生成电子证照?" placement="left" @on-ok="handleClickDetail(row, 'generate')">
                            <p class="action">[生成电子证照]</p>
                        </Poptip>

                        <Poptip v-if="'2'==query.orderStatus" confirm title="确定注销电子证照?" placement="left" @on-ok="handleClickDetail(row, 'logout')">
                            <p class="action">[注销电子证照]</p>
                        </Poptip>
                        <!-- <span @click="handleClickDetail(row, 'pass')" class="action">[审核通过]</span>
                        <span @click="handleClickDetail(row, 'fail')" class="action">[审核不通过]</span> -->
                        <!-- <Poptip confirm title="确认删除?" placement="left" @on-ok="handleClickDetail(row, 'del')">
                            <span class="action">[删除]</span>
                        </Poptip> -->
                    </template>
                </i-table>
                <div class="page">
                    <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
import miment from "miment";
const {
    fwzlxxList,
    delFwzlxx,
    invalidFwzlxx,
    saveFwzlxxDzzz
} = api
export default {
    name: "leaseContract",
    components: {
        pageHead
    },
    filters: {
        formatData(value){
            return miment(Number(value)).format("YYYY-MM-DD")
        }
    },
    data() {
        return {
            title: "租赁合同",
            orderStatusData:[
                {value: 2, label: '已完成'},
                {value: 3, label: '已注销'},
            ],
            btnList: [{
                name: "重置",
                type: "reset",
            },
            {
                name: "搜索",
                type: "search",
            },
            // {
            //     name: "审核通过",
            //     type: "checkPass",
            // },
            // {
            //     name: "审核不通过",
            //     type: "checkFail",
            // },
            {
                name: "批量删除",
                type: "delBatch",
            },
            // {
            //     name: "导出",
            //     type: "export",
            // }
            ],
            query: {
                orderStatus: 2,
                estateUnitNO: "",
                leasee: "",
                leaseeCode: "",
                leasor: "",
                leasorCode: "",
                zlyt: "",
                compactStartdate: "",
                compactEnddate: ""
            },
            tableHeader: [{
                type: "selection",
                width: 70,
                align: "center",
            }, {
                title: "出租方",
                slot: "leasor",
            }, {
                title: "房屋",
                slot: "address",
            }, {
                title: "承租方",
                slot: "leasee",
            }, {
                title: "用途",
                key: "zlyt",
            }, {
                title: "租赁日期",
                slot: "compactData",
            }, {
                title: "合同状态",
                slot: "orderStatus",
            }, {
                title: "操作",
                slot: "action",
            }],
            tableData: [],
            isLoading: false,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            selectedList: [],
            zlyt: ["住宅", "办公", "商业"],
        }
    },
    methods: {
        handleBtn(type) {
            if (type == "reset") {
                this.pageNum = 1;
                this.$refs.search.resetFields();
                this.query.zlyt = ""
                this.loadData();
            } else if (type == "search") {
                this.pageNum = 1;
                this.loadData();
            } else if (type == "delBatch"){
                if (this.selectedList.length == 0) {
                    return this.$Message.warning("请选择要删除的项目");
                }
                this.$Modal.confirm({
                    title: "删除",
                    content: "是否确认删除",
                    okText: "确认",
                    cancelText: "取消",
                    onOk: () => {
                        this.handleDelete(this.selectedList.join(","));
                    },
                });
            }
        },
        async handleDelete(ids){
            let res = await this.$delete(delFwzlxx, {
                id: ids,
            });
            if (res.isSucceed) {
                this.$Message.success("删除成功");
                this.loadData();
            }
        },
        // 注销电子证照
        async handleLogout(orderNO){
            if (!orderNO) return this.$Message.warning("订单号不存在，无法注销");
            let res = await this.$get(invalidFwzlxx, {
                orderNO: orderNO,
            });
            this.$Message.success(res.isSucceed ? "注销电子证照成功" : res.message);
            this.loadData();
        },
        // 生成电子证照
        async handleGenerate(orderNO){
            if (!orderNO) return this.$Message.warning("订单号不存在，无法生成电子证照");
            let res = await this.$get(saveFwzlxxDzzz, {
                orderNO: orderNO,
            });
            this.$Message.success(res.isSucceed ? "生成电子证照成功" : res.message);
        },
        handleClickDetail1(item) {
            this.$router.push({
                name: "leaseContractDetail",
                query: {
                    id: item.id 
                }
            });
        },
        handleClickDetail(item, type){
            if (type == "detail") {
                this.$router.push({
                    name: "leaseContractDetail",
                    query: { id: item.id },
                });
            } else if (type == "del") {
                console.log("del", item.id);
                this.handleDelete(item.id);
            } else if (type == "logout") {
                this.handleLogout(item.orderNO);
            } else if (type == "generate") {
                this.handleGenerate(item.orderNO);
            }
        },
        
        handleSelect(selection) {
            this.selectedList = selection.map(item => item.id)
        },
        pageChange(val) {
            this.pageNum = val;
            this.loadData();
        },
        async loadData() {
            this.isLoading = true;
            console.log(this.query.orderStatus)
            try {
                let res = await this.$post(fwzlxxList, {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    ...this.query,
                });

                this.tableData = res.rows
                this.total = res.total
            } finally {
                this.isLoading = false;
            }
        }
    },
    created() {
        this.loadData();
        console.log(this.$route);
    },
}
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}

.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}

.table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);

    .page {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }

    .action {
        color: #5e6d94;
        cursor: pointer;
        margin-right: 10px;
    }
}
</style>